import {Component, Input, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {BausteinHeaderConfig} from '../../model/baustein-header-config';
import { BausteinContentConfig } from 'src/app/model/baustein-content-config';
import { TariffStatusChangedEventArgs } from 'src/app/model/tariff-status-changed-event-args';
import { TariffConfigurationService } from 'src/app/service/tariff-configuration-service';
import { TrackingService } from 'src/app/service/tracking.service';

import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'node_modules/ngx-loading';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-baustein-header',
  templateUrl: './baustein-header.component.html',
  styleUrls: ['./baustein-header.component.scss']
})
export class BausteinHeaderComponent implements OnInit {

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  @Input() HeaderConfig: BausteinHeaderConfig;
  @Input() ContentConfig: BausteinContentConfig;
  @Output() tariffStatusChanged = new EventEmitter<TariffStatusChangedEventArgs>();

  public showInfo: boolean;

  private tariffConfigSvc: TariffConfigurationService;
  private trackingSvc: TrackingService;
  public apiSvc: ApiService;

  constructor(tariffConfigSvc: TariffConfigurationService, trackingSvc: TrackingService, apiSvc: ApiService) {
    this.tariffConfigSvc = tariffConfigSvc;
    this.trackingSvc = trackingSvc;
    this.apiSvc = apiSvc;
  }

  ngOnInit() {}

  onInfoBoxChanged(isActive: boolean) {
    this.showInfo = isActive;
    if (this.showInfo) {
      this.trackingSvc.trackHelpClick(this.HeaderConfig.headlineWithInfo.headline);
    }
  }

  onSwitchChanged(event: any) {
    const calculationId: string = event.target.id;
    const isTariffActive: boolean = event.target.checked;

    this.tariffConfigSvc.getTariffOptionById(calculationId).active = isTariffActive;

    if (this.tariffStatusChanged) {
      this.tariffStatusChanged.emit(new TariffStatusChangedEventArgs(calculationId, isTariffActive));
    }

  }

  isTariffOptionActive(): boolean {
    return this.tariffConfigSvc.getTariffOptionById(this.HeaderConfig.tariffOption.calculationId).active;
  }

  isTariffOptionDisabled(): boolean {
    return this.tariffConfigSvc.getTariffOptionById(this.HeaderConfig.tariffOption.calculationId).disabled;
  }

}

